





















































































import { positivePass } from "@/utils/rules";
import { createIntegralCardData, createIntegralCardApi } from "@/api/integral";
import { Vue, Component } from "vue-property-decorator";
const max10000 = (rule: any, value: number, callback: any) => {
  if (value > 10000) {
    callback(new Error("积分分值最多为10000"));
  } else {
    callback();
  }
};
const max1000 = (rule: any, value: number, callback: any) => {
  if (value > 1000) {
    callback(new Error("生成数量最多为1000"));
  } else {
    callback();
  }
};
@Component
export default class extends Vue {
  form: any = {};
  dialogVisible: boolean = false;

  rules = {
    integral: [
      { required: true, message: "请填写积分分值", trigger: "blur" },
      { validator: positivePass, trigger: "blur" },
      { validator: max10000, trigger: "blur" },
    ],
    card_name: [{ required: true, message: "请填写名称", trigger: "blur" }],
    num: [
      { required: true, message: "请填写生成数量", trigger: "blur" },
      { validator: positivePass, trigger: "blur" },
      { validator: max1000, trigger: "blur" },
    ],
  };
  openDialog() {
    this.form = {};
    this.dialogVisible = true;
  }
  closeDialog() {
    this.dialogVisible = false;
  }
  inputIntegralLimit() {
    if (this.form.integral > 10000) {
      this.form.integral = 10000;
    }
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const params: createIntegralCardData = {
            card_name: this.form.card_name,
            integral: this.form.integral,
            num: this.form.num,
          };
          if (this.form.remark) {
            params.remark = this.form.remark;
          }
          createIntegralCardApi(params).then(() => {
            this.$message({
              type: "success",
              message: "新增成功",
            });
            this.closeDialog();
            this.$emit("change");
          });
        }
      }
    );
  }
}
